export const GET_CAROUSEL_ITEMS = 'GET_CAROUSEL_ITEMS';
export const CAROUSEL = 'CAROUSEL';
export const themeBg = [
  {
    name: 'verde',
    clase: 'bg-gradiant-green',
  },
  {
    name: 'rojo',
    clase: 'bg-gradiant-red',
  },
  {
    name: 'azul',
    clase: 'bg-gradiant-blue',
  },
  {
    name: 'rosa',
    clase: 'bg-gradiant-pink',
  },
];
